<template>
    <div class="summary">
        <div class="mb-4">
            <current-action v-bind:action="'Check your booking details'"
                            v-bind:summary="'Check you\'re happy with everything and proceed to payment'">
            </current-action>
        </div>

        <div class="summary-container">
            <div v-if="!isLoading">
                <div class="mt-4 mb-4">
                    <booking-summary></booking-summary>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="mb-3"
                     v-bind:class="{'col-24' : booking.legs.length > 1, 'col-lg-12': booking.legs.length === 1}">
                    <div class="has-shadow panel panel--primary h-100 d-flex justify-content-center align-items-center flex-column p-3">
                        <span class="summary-title">
                            Your booking
                        </span>
                        {{dates}}
                    </div>
                </div>
            </div>


            <div class="row justify-content-center">
                <div v-for="leg in booking.legs"
                     v-bind:key="leg.leg" class="col-lg-12">
                    <room-booking-summary v-bind:leg="leg.leg"
                                          v-bind:allowEdit="true"></room-booking-summary>
                </div>
            </div>
        </div>




        <actions-bar>
            <template v-slot:actions>
                <div class="row">
                    <div class="col-12">

                        <button v-on:click="onBack" class="btn btn--transparent btn--back">
                            Back
                        </button>
                    </div>
                    <div class="col-12 d-flex justify-content-end">
                        <button class="btn btn--slate-blue btn--continue"
                                v-on:click="onContinue">
                            Payment
                        </button>
                    </div>
                </div>
            </template>
        </actions-bar>
    </div>


</template>
<script>

    import ActionsBar from '@/shared/components/ActionsBar.vue';

    import CurrentAction from '../components/CurrentAction.vue';
    import RoomBookingSummary from '../components/RoomBookingSummary.vue';

    import { store } from '../store/index';

    export default {
        name: 'StaySummary',

        components: {
            ActionsBar,
            CurrentAction,
            RoomBookingSummary
        },
        data() {
            return {
                isLoading: false
            }
        },
        computed: {
            session() {
                return store.getters.session
            },
            booking() {
                return store.getters.booking;
            },
            dates() {
                var search = store.getters.search;
                var arrivalDate = moment(search.arrivalDate);
                var departureDate = moment(search.arrivalDate).add(+search.numberOfNights, 'd');

                if ((arrivalDate.year() == departureDate.year()) && (arrivalDate.month() == departureDate.month())) {
                    return arrivalDate.format('ddd Do') + '-' + departureDate.format('ddd Do MMM YY');
                }
                if (arrivalDate.year() == departureDate.year()) {
                    return arrivalDate.format('ddd Do MMM') + '-' + departureDate.format('ddd Do MMM YY');
                }
                return arrivalDate.format('ddd Do MMM YY') + '-' + departureDate.format('ddd Do MMM YY');

            }
        },
        methods: {

            onBack() {
                this.$router.push({ name: 'stay_details', params: { id: this.session.Id } });

            },
            onContinue: function () {
                this.isSubmitting = true;
                this.isLoading = true;
           
                store.dispatch("stageBooking").then(() => {
                    this.isSubmitting = false;
                    this.isLoading = false;
                    this.$router.push({ name: 'stay_payment', params: { id: this.session.Id } });
                });

            }
        }
    }
</script>

<style src="@/shared/css/summary.css"></style>

